// @ts-check
import React from 'react'
import { Label, Error } from '..'
import { isEmpty, isNil } from 'ramda'
import styles from './style.css'
import { validateUTF8StringLength } from '../../utils/validateUTFStringLength'

/**
 * @param {{
 * id?: string,
 * type?: string,
 * placeholder?: string,
 * value: string,
 * label: string,
 * onChange?: {(event: React.ChangeEvent): void},
 * onKeyDown?: {(event: React.KeyboardEvent): void},
 * onBlur?: {(event: React.FocusEvent): void},
 * error: string | React.Component,
 * disabled?: boolean,
 * required?: boolean,
 * valid: boolean,
 * name: string,
 * maxLength?: number,
 * showLabelAsPlaceholder?: boolean,
 * info?: string,
 * classNameError?: string }} props
 */
const InputText = ({
  id,
  label,
  error,
  showLabelAsPlaceholder,
  valid,
  info,
  name,
  type,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  required,
  maxLength,
  onKeyDown,
  classNameError
}) => {
  /**
   * @type {string}
   */
  const htmlFor = id ?? label
  const className = !isEmpty(error) && !isNil(error) ? styles.inputInvalid : ''
  const onChangeHandler = (event) => {
    const { target: { value } } = event
    if (maxLength) {
      if (validateUTF8StringLength(value, maxLength)) {
        onChange(event)
      }
    } else {
      onChange(event)
    }
  }

  return (
    <div className={styles.field}>
      {!showLabelAsPlaceholder && (
        <Label htmlFor={htmlFor} value={label} valid={valid} info={info} />
      )}
      <input
        className={`${styles.input} ${className}`}
        id={htmlFor}
        name={name}
        type={type}
        placeholder={showLabelAsPlaceholder ? label : placeholder}
        value={value}
        onChange={onChangeHandler}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
        maxLength={maxLength}
        autoComplete='nope'
        onKeyDown={onKeyDown}
      />
      <Error value={error} className={classNameError} />
    </div>
  )
}

InputText.defaultProps = {
  type: 'text',
  placeholder: '',
  onChange: () => {},
  onBlur: () => {},
  disabled: false,
  required: false,
  maxLength: 300
}

export { InputText }
